import { render, staticRenderFns } from "./VragenForm.vue?vue&type=template&id=b3099a60&scoped=true&"
import script from "./VragenForm.vue?vue&type=script&lang=js&"
export * from "./VragenForm.vue?vue&type=script&lang=js&"
import style0 from "./VragenForm.vue?vue&type=style&index=0&id=b3099a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3099a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VFlex,VForm,VLayout,VTextField,VTextarea})
